import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MesActionsListPage} from './MesActionsListPage'
import MesActionsAddPage from './MesActionsAddPage'
import MesActionsEditPage from './MesActionsEditPage'

const MesActionsWrapper = () => {
  const [filtersActive, setFiltersActive] = useState({
    view: 'List',
    allSearch: '',
    statut: '',
    type: '',
    origine: '',
    dateMin: '',
    dateMax: '',
    mesActions: false
  })

  const handleFilterArian = (view, filters) => {
    setFiltersActive({
      view: view,
      ...filters
    })
  }

  return (
    <>
      <Routes>
        <Route path='/liste' element={
          <>
            <PageTitle breadcrumbs={[
              {
                title: 'Paramètres',
                path: '#',
                isSeparator: false,
                isActive: true,
              }
            ]}>Mes actions</PageTitle>
            <MesActionsListPage />
          </>
        } />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                  { title: 'Mes actions', path: '/mes-actions/liste', state: {view: filtersActive?.view, filters: filtersActive}, isSeparator: false, isActive: true },
                ]}
                state={{view: filtersActive?.view, filters: filtersActive}}
              >Création</PageTitle>
              <MesActionsAddPage handleFilterArian={handleFilterArian}/>
            </>
          }
        />
        <Route
          path='/:actionId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  { title: 'Paramètres', path: '#', isSeparator: false, isActive: false },
                  { title: 'Mes actions', path: '/mes-actions/liste', state: {view: filtersActive?.view, filters: filtersActive}, isSeparator: false, isActive: true },
                ]}
                state={{view: filtersActive?.view, filters: filtersActive}}
              >Modification</PageTitle>
              <MesActionsEditPage handleFilterArian={handleFilterArian}/>
            </>
          }
        />

        <Route index element={<Navigate to='/mes-actions/liste' />} />
      </Routes>
    </>
  )
}

export {MesActionsWrapper}
